import React, { useState } from 'react';
import { Button, Input, Modal } from 'antd';
import PreviewAddNote from '../PreviewAddNote';
import type { OrderForTableReceive } from '../types';

interface AddNoteProps {
  order: OrderForTableReceive;
}

const { TextArea } = Input;

const AddNote = ({ order }: AddNoteProps) => {
  const [isOpenAddNoteModal, setIsOpenAddNoteModal] = useState(false);
  const [isOpenPreviewAddNoteModal, setIsOpenPreviewAddNoteModal] =
    useState(false);
  const [note, setNote] = useState('');

  const closeAddNoteModal = () => {
    if (isOpenPreviewAddNoteModal) {
      setIsOpenPreviewAddNoteModal(false);
    }
    setNote('');
    setIsOpenAddNoteModal(false);
  };

  const addedNoteOrder = {
    ...order,
    note,
  };

  return (
    <>
      <Modal
        open={isOpenAddNoteModal}
        okText="預覽"
        title="新增備註"
        onCancel={closeAddNoteModal}
        onOk={() => setIsOpenPreviewAddNoteModal(true)}
      >
        <TextArea
          rows={4}
          value={note}
          placeholder="請輸入備註"
          maxLength={100}
          showCount
          onChange={(event) => setNote(event.target.value)}
        />
      </Modal>
      <Button onClick={() => setIsOpenAddNoteModal(true)}>備註</Button>
      <PreviewAddNote
        open={isOpenPreviewAddNoteModal}
        order={addedNoteOrder}
        closeAddNoteModal={closeAddNoteModal}
      />
    </>
  );
};

export default AddNote;
